import React, { useEffect, useState } from 'react';

import { Text, VStack } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import DeliveryLocationDisplay from '../../../shared/components/deliveryLocation/deliveryLocationDisplay';
import { errorHandler } from '../../../shared/components/errorHandler/errorHander';
import { quoteSetter } from '../../../shared/reducers/quote.reducer';
import { firebaseApp } from '../../../shared/services/firebase/firebaseFactory';
import { cleanFirestoreResult } from '../../../shared/util/firestore-utils';

function QuoteSelectLocation() {
  const [car, setCar] = useState({});
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.users.currentUser);
  const quote = useSelector((state) => state.quote.quote);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser?.uid) {
      setLoading(true);
      firebaseApp
        .firestore()
        .collection('cars')
        .doc(quote?.carId)
        .get()
        .then((resCar) => {
          setCar(cleanFirestoreResult(resCar));
          setLoading(false);
        })
        .catch((e) => {
          errorHandler(e, true);
          setLoading(false);
        });
    }
  }, [currentUser?.uid, quote?.carId]);

  function selectLocation(location) {
    dispatch(quoteSetter({ ...quote, location: location }));
  }

  return (
    <VStack space={'lg'}>
      <Text variant={'grey'} size={'secondary'}>
        {t('quote.bookingSubTitle')}
      </Text>
      <DeliveryLocationDisplay loading={loading} car={car} location={quote?.location} setLocation={selectLocation} />
    </VStack>
  );
}

export default QuoteSelectLocation;
